module.exports = __webpack_public_path__ + "static/media/icon-character__angela-merkel.95db77d1.svg";